import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">热度榜单</h2>
          <p className="text-foreground-500 text-sm md:text-base">全网最热黑料与吃瓜事件实时排名</p>
        </div>
        <div className="max-w-3xl mx-auto">
          {rankingData.map((item, i) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 border-b border-background-200 last:border-b-0 hover:bg-background-50/50 transition-colors cursor-pointer group animate-fade-in-up"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg font-heading font-black text-sm ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-300 text-background-50' :
                item.rank === 3 ? 'bg-accent-400 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-foreground-800 text-sm md:text-base font-medium truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className={`text-xs font-bold ${
                  item.change === 'up' ? 'text-primary-500' :
                  item.change === 'new' ? 'text-accent-500' :
                  'text-secondary-500'
                }`}>
                  {item.change === 'up' && <i className="ri-arrow-up-line"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line"></i>}
                  {item.change === 'new' && <i className="ri-flashlight-line"></i>}
                </span>
                <span className="text-xs text-foreground-400 font-medium">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}